var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFace2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 62,
    viewBox: "0 0 74 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.945 31.6444C5.93366 25.369 7.74194 19.2302 11.1425 14C1.44499 24.6463 0.5 62 0.5 62H27.5C21.2308 59.8985 15.772 55.8327 11.9016 50.382C8.03114 44.9314 5.9466 38.374 5.945 31.6444Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.01 15.628C61.8444 10.1736 57.0915 5.81745 51.387 3.14236C48.5147 1.76887 45.4535 0.833656 42.3049 0.367779C40.9306 0.145062 39.5419 0.0234439 38.1499 0.00389938C33.905 -0.062271 29.6891 0.714303 25.7455 2.2888C21.8019 3.8633 18.2086 6.20454 15.1731 9.1774C12.1376 12.1503 9.71992 15.6959 8.05967 19.6096C6.39943 23.5233 5.52947 27.7276 5.5 31.9799H55.1333C55.1333 31.9799 55.7009 26.6354 56.0188 25.1571C57.3357 19.1076 58.7661 17.7885 58.7661 17.7885C63.8066 28.523 69.0515 32.2983 69.2558 32.4347C69.1469 39.0061 67.0018 45.3812 63.1172 50.6779C59.2325 55.9747 53.8004 59.9311 47.5725 62H73.4563C73.4563 62 74.6143 29.0688 65.01 15.628Z",
    fill: "#3098F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace2);
export default __webpack_public_path__ + "static/media/face2.31f19ed2350061bb23de6e98d2a81de7.svg";
export { ForwardRef as ReactComponent };